import Seo from "../components/Seo";
import { COMPANY } from "../data/content";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "Trendsight Media Private Limited respects your privacy. Information submitted through our website forms — such as your name, email, phone number and project details — is used solely to respond to your enquiry and, where relevant, to deliver our services.",
      "We do not sell, rent or share your personal information with third parties for their marketing purposes. Enquiry data is stored securely and access is restricted to authorized team members.",
      "Our website may use privacy-respecting analytics to understand aggregate visitor behaviour and improve the experience. You may request access to, or deletion of, your personal data at any time by writing to " + COMPANY.email + ".",
    ],
  },
  terms: {
    title: "Terms & Conditions",
    body: [
      "This website is operated by Trendsight Media Private Limited (CIN: " + COMPANY.cin + "). By using this website you agree to these terms.",
      "Content on this website, including case studies marked as illustrative, is provided for general information. Illustrative figures demonstrate our reporting format and are not verified client results.",
      "Service engagements are governed by individual agreements signed between Trendsight Media Private Limited and the client. Submitting an enquiry does not create a client relationship.",
      "All website content, branding and materials are the property of Trendsight Media Private Limited and may not be reproduced without written permission.",
    ],
  },
  disclaimer: {
    title: "Disclaimer",
    body: [
      "The information on this website is provided in good faith for general guidance. While we work to keep it accurate, Trendsight Media Private Limited makes no warranties about completeness or suitability for a particular purpose.",
      "Marketing outcomes depend on many factors including market conditions, budgets, creative approvals and platform changes. Past or illustrative performance does not guarantee future results.",
      "Case study figures marked 'Illustrative' are demonstrations only. For questions, contact us at " + COMPANY.email + ".",
    ],
  },
};

export default function Legal({ kind }) {
  const page = CONTENT[kind] || CONTENT.privacy;
  return (
    <main className="pt-32 pb-24" data-testid={`legal-${kind}-page`}>
      <Seo title={page.title} description={`${page.title} of Trendsight Media Private Limited, Delhi.`} />
      <div className="max-w-3xl mx-auto px-4 sm:px-8">
        <p className="font-mono-accent text-xs uppercase tracking-[0.35em] text-blue-400 mb-5">Legal</p>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight text-slate-50" data-testid="legal-title">{page.title}</h1>
        <p className="mt-4 text-sm text-slate-500">Last updated: July 2026 · {COMPANY.name}</p>
        <div className="mt-10 space-y-6">
          {page.body.map((p, i) => (
            <p key={i} className="text-base text-slate-400 leading-relaxed">{p}</p>
          ))}
        </div>
      </div>
    </main>
  );
}
